import React from "react";

// Dashboard
const AssestsDashboard = React.lazy(() => import("../../Assets/dashboard"));

// Assets
const AssetsTable = React.lazy(() =>
  import("../../Assets/assetspages/assets").then((m) => ({
    default: m.AssetsTable,
  })),
);
const AssestsAdd = React.lazy(() =>
  import("../../Assets/assetspages/assets").then((m) => ({
    default: m.AssestsAdd,
  })),
);

// Sell Assets
const SellAssetsTable = React.lazy(() =>
  import("../../Assets/assetspages/sellassets").then((m) => ({
    default: m.SellAssetsTable,
  })),
);
const SellAssestsAdd = React.lazy(() =>
  import("../../Assets/assetspages/sellassets").then((m) => ({
    default: m.SellAssestsAdd,
  })),
);

// Buyer/Lender
const LenderTableComp = React.lazy(() =>
  import("../../Assets/assetspages/assetbuyer").then((m) => ({
    default: m.LenderTableComp,
  })),
);
const AddLender = React.lazy(() =>
  import("../../Assets/assetspages/assetbuyer").then((m) => ({
    default: m.AddLender,
  })),
);

// Seller
const SellerTable = React.lazy(() => import("../../Inventory/LandAndSeller/Seller/SellerTable"));
const SellerForm = React.lazy(() => import("../../Inventory/LandAndSeller/Seller/SellerForm"));

// Maintenance
const MaintenenceAssetsTable = React.lazy(() =>
  import("../../Assets/assetspages/maintainence").then((m) => ({
    default: m.MaintenenceAssetsTable,
  })),
);
const MaintenenceAssestsAdd = React.lazy(() =>
  import("../../Assets/assetspages/maintainence").then((m) => ({
    default: m.MaintenenceAssestsAdd,
  })),
);

// Depreciation
const DepriciationComp = React.lazy(() => import("../../Assets/assetspages/depreciation"));

export const assetRoutes = [
  {
    path: "/asset/dashboard",
    Component: AssestsDashboard,
    rolename: "Asset Dashboard",
  },

  // Assets
  {
    path: "/assets/asset",
    Component: AssetsTable,
    rolename: "Add Asset",
  },
  {
    path: "/assets/asset/add",
    Component: AssestsAdd,
    rolename: "Add Asset",
  },

  // Sell Assets
  {
    path: "/assets/sale",
    Component: SellAssetsTable,
    rolename: "Sell",
  },
  {
    path: "/assets/sale/add",
    Component: SellAssestsAdd,
    rolename: "Sell",
  },

  // Buyer
  {
    path: "/assets/buyer",
    Component: LenderTableComp,
    rolename: "Buyer",
  },
  {
    path: "/assets/buyer/add",
    Component: AddLender,
    rolename: "Buyer",
  },

  // Seller
  {
    path: "/assets/seller",
    Component: SellerTable,
    rolename: "Seller",
  },
  {
    path: "/asset/seller/add",
    Component: SellerForm,
    rolename: "Seller",
  },

  // Maintenance
  {
    path: "/asset/maintainance",
    Component: MaintenenceAssetsTable,
  },
  {
    path: "/asset/maintainance/add",
    Component: MaintenenceAssestsAdd,
  },

  // Depreciation
  {
    path: "/asset/depriciation",
    Component: DepriciationComp,
  },
];
